var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.25C4.37665 1.25 2.25 3.37665 2.25 6C2.25 8.62335 4.37665 10.75 7 10.75H8.25V15C8.25 15.4142 8.58579 15.75 9 15.75C9.41421 15.75 9.75 15.4142 9.75 15V2.75H14.25V15C14.25 15.4142 14.5858 15.75 15 15.75C15.4142 15.75 15.75 15.4142 15.75 15V2.75H21C21.4142 2.75 21.75 2.41421 21.75 2C21.75 1.58579 21.4142 1.25 21 1.25H7ZM7 2.75H8.25V9.25H7C5.20507 9.25 3.75 7.79493 3.75 6C3.75 4.20507 5.20507 2.75 7 2.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28701 13.3071C6.00676 13.191 5.68417 13.2552 5.46967 13.4697L1.46967 17.4697C1.17678 17.7626 1.17678 18.2375 1.46967 18.5304L5.46967 22.5304C5.68417 22.7449 6.00676 22.809 6.28701 22.6929C6.56727 22.5768 6.75 22.3034 6.75 22V18.75H22C22.4142 18.75 22.75 18.4142 22.75 18C22.75 17.5858 22.4142 17.25 22 17.25H6.75V14C6.75 13.6967 6.56727 13.4232 6.28701 13.3071Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionRtl);
export default __webpack_public_path__ + "static/media/direction-rtl.0d8cc6b2a1135a094c9e840f8ec970d9.svg";
export { ForwardRef as ReactComponent };